import * as types from '../actionTypes'

export function toggleMobileMenu(visible) {
    return {
        type: types.SET_MENU_MOBILE,
        payload: { visible },
    }
}
